module.exports = __webpack_public_path__ + "static/media/fa-dollar.29bce32e.png";